import EventsDispatcher from './EventsDispatcher.js';

const SocketStatus = {
    INITIAL:  1,
    CONNECTED: 2,
    DISCONNECTED: 3,
    REJECTED: 4
}
Object.freeze(SocketStatus);
class NotificationsSocket extends EventsDispatcher
{
    
    constructor(socketURL, connectionToken, autoReconnect = true)
    {
        super();
        this.connectionToken = connectionToken;
        this.autoReconnect = autoReconnect;
        this.alreadyConnected = false;
        this.socket = null;
        this.socketURL = socketURL;
        this.pingTimer = null;
        this.pingInterval = 20000;
        this.status = SocketStatus.INITIAL;
        this.msgCount = 1;
        this._connect();
        window.addEventListener('beforeunload', () => {
            this.Log("BeforeUnload!");
            console.log(this.status);
            if(this.status === SocketStatus.CONNECTED)
            {
                this._SendRaw("DISCONNECT");
            }
        });
    }

    _ping()
    {
        if (this.socket && this.socket.readyState === this.socket.OPEN) {  
            this.socket.send('PING');  
            console.log("ping");
        }
    }

    _handleOnOpen = () => {
        this.Log("Websocket Opened");
        if(this.status === SocketStatus.INITIAL || this.status === SocketStatus.REJECTED)
        {
            this._SendRaw("CONNECT WebApp/"+this.connectionToken);
        }
        else if(this.status === SocketStatus.DISCONNECTED)
        {
            this._SendRaw("RECONNECT WebApp/"+this.connectionToken);
        }
        

        // set keep alive timeout
        if(this.pingTimer != null) clearInterval(this.pingTimer);
        this.pingTimer = setInterval(this._ping, this.pingInterval);
    }

    _handleOnClose = () => {
        this.Log("WebSocket Closed");
        if(this.status !== SocketStatus.REJECTED) this.status = SocketStatus.DISCONNECTED;

        if(this.pingTimer != null) clearInterval(this.pingTimer);
        this.pingTimer = null;
        if(this.autoReconnect) setTimeout(() => this._connect(), 5000);
        this.dispatch("socketDisconnected");
        this._cleanup();
    }

    _handleOnError = () => {
        this._handleOnClose();
    }

    _connect()
    {
        if(this.status === SocketStatus.CONNECTED) return;

        this.socket = new WebSocket(this.socketURL);
        this.socket.addEventListener('open', this._handleOnOpen);
        this.socket.addEventListener('close', this._handleOnClose);
        this.socket.addEventListener('error', this._handleOnError);
        this.socket.addEventListener('message', this._handleOnMessage);
    }

    Log(message)
    {
        console.log(message);
    }

    Send(topic, target, content)
    {
        let message = {msgID: this.msgCount, content: content, topic: topic, target: target};
        this.msgCount++;
        this._SendRaw(`MSG ${JSON.stringify(message)}`);
    }

    _SendRaw(message)
    {
        this.Log("SENT: " + message);
        if(this.socket != null && this.socket.readyState === WebSocket.OPEN) this.socket.send(message);
    }

    _handleOnMessage = (ev) => {
        this._parseMessage(ev.data);
    }

    _cleanup()
    {
        if(this.socket)
        {
            this.socket.removeEventListener('open', this._handleOnOpen);
            this.socket.removeEventListener('close', this._handleOnClose);
            this.socket.removeEventListener('error', this._handleOnError);
            this.socket.removeEventListener('message', this._handleOnMessage);
        }
    }

    _parseMessage = (message) =>
    {
        var command = message.split(/ (.+)/)[0];
        var payload = message.split(/ (.+)/)[1];

        switch(command)
        {
            case 'CONNECTED':
                this.status = SocketStatus.CONNECTED;
                this.Log("Socket Connected");
                this.dispatch("socketConnected");
            break;
            case 'DISCONNECTED':
                this.status = SocketStatus.REJECTED;
                this.socket.close();
                break;
            case 'MSG':
                let notification = JSON.parse(payload);
                console.log(notification);
                this.dispatch(notification.topic, notification.content, notification.target);
                this._SendRaw(`ACK ${notification.msgID}`);
                // ack
                break;
            case 'PING':
                this._SendRaw("PONG");
                break;
            case 'ACK':
                // ignored
                break;
            default:
                this._websocket.send("UNKNOWN COMMAND: "+command);
                console.log("unknown command: %s", command);
                break;
        }
    }
}

export default NotificationsSocket;